import React from 'react';
import { Button } from './ui/button';
import { Download } from 'lucide-react';
import { API } from '../lib/api';

export const AuditExportButton = ({ label = 'Export Audit CSV' }) => {
  const [busy, setBusy] = React.useState(false);

  const handle = async () => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/audit/export`, { credentials: 'include' });
      if (!r.ok) throw new Error('Failed');
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const cd = r.headers.get('Content-Disposition') || '';
      const m = cd.match(/filename=([^;]+)/i);
      a.href = url;
      a.download = m ? m[1].trim() : `akta_audit_${Date.now()}.csv`;
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } finally { setBusy(false); }
  };

  return (
    <Button onClick={handle} disabled={busy} variant="outline" className="border-brand-border text-brand-indigo">
      <Download className="h-4 w-4 mr-2" /> {busy ? 'Preparing\u2026' : label}
    </Button>
  );
};

export default AuditExportButton;
